import { useEffect, useState } from "react";
import { api } from "./lib/api";
import LoginPage from "./components/LoginPage";
import Portal from "./components/Portal";

export default function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    api.session().then(setAuthed);
  }, []);

  if (authed === null) {
    return (
      <div className="h-full flex items-center justify-center text-zinc-500 text-sm">
        Loading…
      </div>
    );
  }

  if (!authed) {
    return <LoginPage onLogin={() => setAuthed(true)} />;
  }

  return <Portal onUnauthorized={() => setAuthed(false)} />;
}
